import { streetOrientationToName } from "building-common/streetOrientation/streetOrientationTools";
import { getActiveProfileTable } from "building-generation/elements/profileTools";
import { DEFAULT_CORNER_TRIM_PROFILE_DESCRIPTOR } from "building-types/profiles/defaultBoardTrimProfiles";
import { ProfileExtrusionDescriptorType } from "building-types/profiles/profileTypesEnum";
import { ValidCornerCondition } from "building-types/trim/cornerBoardTypes";
import { worldInchesNew } from "common/utils/nominalNumbers";
import { polyLine3Length } from "geom/polyLine3";
import type { ExteriorTrimCollectionBuilding, TrimKeyMeasure } from "./trimTypes";

export function getCornerBoardTrims(
  building: ExteriorTrimCollectionBuilding,
  trimKeyMeasures: TrimKeyMeasure[] = [],
): TrimKeyMeasure[] {
  if (!building) {
    return trimKeyMeasures;
  }

  const { cornerBoards, settings, enabledFeatures, doc } = building;
  const { profile, exteriorTrim } = settings;
  const profileTable = getActiveProfileTable({
    settingsToCatalogs: enabledFeatures.settingsToCatalogs,
    profiles: doc.profiles,
    profileSettings: profile,
  });

  for (const cornerBoardId in cornerBoards) {
    const cornerBoard = cornerBoards[cornerBoardId];
    cornerBoard.rails.forEach((cornerBoardRail) => {
      const { profileId, cornerCondition, rail, streetOrientation } = cornerBoardRail;
      const isInside = cornerCondition === ValidCornerCondition.INSIDE;
      const length = polyLine3Length(rail);
      const materialSlot = isInside
        ? exteriorTrim?.insideCornerBoardMaterial
        : exteriorTrim?.outsideCornerBoardMaterial;

      const descriptor = profileId
        ? profileTable[profileId] ?? DEFAULT_CORNER_TRIM_PROFILE_DESCRIPTOR
        : DEFAULT_CORNER_TRIM_PROFILE_DESCRIPTOR;
      let height: number | undefined;
      let width: number | undefined;
      if (descriptor.profileType === ProfileExtrusionDescriptorType.BOARD) {
        height = descriptor.height;
        width = descriptor.width;
      }
      trimKeyMeasures.push({
        category: isInside ? "INSIDE_CORNER_BOARDS" : "CORNER_BOARDS",
        name: descriptor.name,
        length: worldInchesNew(length),
        profileId,
        height: height ? worldInchesNew(height) : undefined,
        width: width ? worldInchesNew(width) : undefined,
        materialSlot,
        rail,
        streetOrientation: streetOrientationToName(streetOrientation),
      });
    });
  }

  return trimKeyMeasures;
}
